// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString));
var fieldLabelIsSymbol = {
    reflectSymbol: function () {
        return "fieldLabel";
    }
};
var fieldNameIsSymbol = {
    reflectSymbol: function () {
        return "fieldName";
    }
};
var internalIsSymbol = {
    reflectSymbol: function () {
        return "internal";
    }
};
var messageIsSymbol = {
    reflectSymbol: function () {
        return "message";
    }
};
var ordMaybe = /* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString));
var union = /* #__PURE__ */ Data_Map_Internal.union(ordMaybe);
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString));
var arrayEncode = /* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode);
var arrayDecode = /* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode);
var asJSONKeyMaybe = /* #__PURE__ */ Data_Map_Serialized.asJSONKeyMaybe(arrayEncode)(arrayDecode);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var arrayEncode1 = /* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(messageIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(internalIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))(fieldNameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(arrayEncode))))(fieldLabelIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))));
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var arrayDecode1 = /* #__PURE__ */ Foreign_Generic_Class.arrayDecode(/* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(messageIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())(internalIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())(fieldNameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(arrayDecode)))())(fieldLabelIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))()));
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var FormErrors = function (x) {
    return x;
};
var showFormErrors = /* #__PURE__ */ Data_Map_Internal.showMap(showMaybe)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(fieldLabelIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(fieldNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(internalIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(messageIsSymbol)(Data_Show.showString))(Data_Show.showBoolean))(showMaybe))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))));
var semigroupFormErrors = {
    append: function (v) {
        return function (v1) {
            return union(v)(v1);
        };
    }
};
var newtypeFormErrors_ = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidFormErrors = {
    mempty: /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Map_Internal.monoidMap(ordMaybe)),
    Semigroup0: function () {
        return semigroupFormErrors;
    }
};
var eqFormErrors = /* #__PURE__ */ Data_Map_Internal.eqMap(eqMaybe)(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(messageIsSymbol)(Data_Eq.eqString))()(internalIsSymbol)(Data_Eq.eqBoolean))()(fieldNameIsSymbol)(eqMaybe))()(fieldLabelIsSymbol)(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))));
var encodeFormErrors = {
    encode: /* #__PURE__ */ (function () {
        var $138 = Foreign_Generic_Class.encode(Data_Map_Serialized.encodeMap(asJSONKeyMaybe)(arrayEncode1)(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(arrayEncode1))));
        return function ($139) {
            return $138(Data_Map_Serialized.SerializedMap(unwrap($139)));
        };
    })()
};
var decodeFormErrors = {
    decode: /* #__PURE__ */ (function () {
        var $140 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function ($143) {
            return wrap(Data_Map_Serialized.fromSerializedMap($143));
        });
        var $141 = Foreign_Generic_Class.decode(Data_Map_Serialized.decodeMap(ordMaybe)(asJSONKeyMaybe)(arrayDecode1)(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(arrayDecode1))));
        return function ($142) {
            return $140($141($142));
        };
    })()
};
var userVisibleErrors = function (errors) {
    return wrap(Data_Map_Internal.singleton(Data_Maybe.Nothing.value)(mapFlipped(errors)(function (message) {
        return {
            fieldName: Data_Maybe.Nothing.value,
            fieldLabel: Data_Maybe.Nothing.value,
            message: message,
            internal: false
        };
    })));
};
var userVisibleError = function (message) {
    return userVisibleErrors([ message ]);
};
var isEmpty = function (v) {
    return Data_Map_Internal.isEmpty(v);
};
var internalErrorForField = function (fieldName) {
    return function (message) {
        return wrap(Data_Map_Internal.singleton(new Data_Maybe.Just(fieldName))([ {
            fieldName: new Data_Maybe.Just(fieldName),
            fieldLabel: Data_Maybe.Nothing.value,
            message: message,
            internal: true
        } ]));
    };
};
var internalError = function (message) {
    return wrap(Data_Map_Internal.singleton(Data_Maybe.Nothing.value)([ {
        fieldName: Data_Maybe.Nothing.value,
        fieldLabel: Data_Maybe.Nothing.value,
        message: message,
        internal: true
    } ]));
};
var unknownError = /* #__PURE__ */ internalError("Unknown error");
var formErrorsToArray = /* #__PURE__ */ (function () {
    var $144 = Data_Array.fromFoldable(Data_Map_Internal.foldableMap);
    return function ($145) {
        return Data_Array.concat($144(unwrap($145)));
    };
})();
export {
    FormErrors,
    isEmpty,
    unknownError,
    internalError,
    internalErrorForField,
    userVisibleError,
    userVisibleErrors,
    formErrorsToArray,
    newtypeFormErrors_,
    semigroupFormErrors,
    monoidFormErrors,
    eqFormErrors,
    showFormErrors,
    encodeFormErrors,
    decodeFormErrors
};
